import * as React from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import { hasValue } from '../../lib/utils';
import './RequesterNotesForReferee.less';
import Checkbox from './fields/Checkbox';
import { getRefereeToken } from '../../core/session';
import { setRefereeNotesConsent } from '../../core/api';
import { SanitizedHTML } from './rhf/LinkModule';

const RequesterNotesForReferee = (props: Props) => {
	const [refereesNotesConsent, setRefereesNotesConsent] = React.useState<boolean>(props.consentToNotes);

	if (hasValue(props.notes)) {
		return (
			<div className={classNames('borderContent', 'greyStyle')}>
				<Label dangerouslySetInnerHTML={{ __html: SanitizedHTML(props.notes) }} />
				<CheckboxContainer>
					<Checkbox
						value={refereesNotesConsent}
						onValueChange={async (fieldName, value: boolean) => {
							setRefereesNotesConsent(value);
							await setRefereeNotesConsent(getRefereeToken(), value);
						}}
						name="RefereeNotesConsent"
						label=""
					/>
					I have read the instructions
					{!refereesNotesConsent && <RequiredLabel>Required</RequiredLabel>}
				</CheckboxContainer>
			</div>
		);
	}
	return null;
};

interface Props {
	notes: string;
	consentToNotes: boolean;
}

export default RequesterNotesForReferee;

const Label = styled.label`
	font-size: 16px;
	height: 38px;
	line-height: 24px;
	width: 100%;
	color: rgb(84, 105, 141);
`;

const RequiredLabel = styled.label`
	font-size: 12px;
	width: 100%;
	color: red;
	margin: -25px 0 0 25px;
`;

const CheckboxContainer = styled.div`
	font-size: 15px;
	width: 100%;
	margin-top: 10px;
	color: rgb(84, 105, 141);
	input {
		margin-top: -2px;
	}
`;
